import { render } from "./Contact.vue?vue&type=template&id=ce237962"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"
script.render = render

export default script